import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {ScreenGuardComponent} from './screen-guard.component';

@NgModule({
  declarations: [ScreenGuardComponent],
  imports: [CommonModule, RouterModule, ReactiveFormsModule],
  exports: [ScreenGuardComponent],
})
export class ScreenGuardModule {}



// WEBPACK FOOTER //
// ./src/app/screen-guard/screen-guard.module.ts